import { ExternalLink } from 'lucide-react';
import { useLocation } from 'src/lib/routing';
import { useBannerClass } from 'src/hooks/useBannerClass';

import { useConnectedClient } from 'context/ConnectedClientContext';
import { getImpersonationToken, isImpersonating } from 'utils/impersonation';

export function emailToHue(email: string): number {
  let hash = 0;
  for (let i = 0; i < email.length; i++) {
    hash = email.charCodeAt(i) + ((hash << 5) - hash);
  }
  return ((hash % 360) + 360) % 360;
}

export const ImpersonationBanner = () => {
  const { details } = useConnectedClient();
  const location = useLocation();
  const active = isImpersonating();

  useBannerClass(active);

  if (!active) {
    return null;
  }

  const token = getImpersonationToken();
  const email = details?.email ?? 'unknown';
  const hue = emailToHue(email);
  const currentUrl = `${location.pathname}${location.search}`;
  const newTabUrl = `${currentUrl}#access_token=${token}`;

  return (
    <div
      className="flex h-[46px] shrink-0 items-center justify-center gap-2 p-2 text-center text-xs text-white sm:text-sm"
      style={{ backgroundColor: `hsl(${hue}, 70%, 35%)` }}
    >
      <span>
        Viewing as <strong>{email}</strong>
      </span>
      <a
        href={newTabUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 underline hover:opacity-80"
      >
        Open in New Tab <ExternalLink className="inline size-3" />
      </a>
    </div>
  );
};
